import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import { SnackbarComponent } from '@components/overlays/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  snackBarConfig: MatSnackBarConfig;
  snackBarRef: MatSnackBarRef<any>;
  horizontalPosition: MatSnackBarHorizontalPosition;
  verticalPosition: MatSnackBarVerticalPosition;
  type: string | string[];

  constructor(public snackBar: MatSnackBar) {}

  openSnackBar(
    message: string,
    type: string | string[],
    action: string = '',
    showCloseBtn: boolean = true,
    duration: number = 5000
  ) {
    return this.snackBar
      .openFromComponent(SnackbarComponent, {
        data: {
          message,
          action,
          showCloseBtn,
          type
        },
        verticalPosition: 'top',
        horizontalPosition: type === 'snackbar' ? 'center' : 'right',
        duration: type === 'snackbar' ? duration : 10000
      })
      .onAction();
  }
}
